import { gql } from "@apollo/client";

const UPDATE_FULFILLMENT_TRACKING_DETAILS_SETTING = gql`
  mutation updateFulfillmentTrackingDetailsSetting($input: ManageFulfillmentTrackingInput!) {
    updateFulfillmentTrackingDetailsSetting(input: $input) {
      status
      data
      error
    }
  }
`;
export default UPDATE_FULFILLMENT_TRACKING_DETAILS_SETTING;
